var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDog107(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_107"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_107",
    "data-name": 107,
    className: "cls-2",
    d: "M87.25,11.53C96.69,25.58,81,49.22,73,61.33c-6.26,9.43-25.76,38.76-46.53,35.76-9.7-1.4-20.38-7.27-18.19-18.6a33.93,33.93,0,0,1,4.23-10A481.9,481.9,0,0,1,45.56,18.41c4.83-6.49,10.51-15.2,19.36-16.09C73.05,1.5,82.7,4.76,87.25,11.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cat_304"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3,
    y: -59,
    width: 100,
    height: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog107);
export default __webpack_public_path__ + "static/media/dog_107.07954d6f799754390fc858f181cf41f2.svg";
export { ForwardRef as ReactComponent };